import styled from 'styled-components'

export const ModeSelectionContainer = styled.div`
    display: flex;

    button {
        flex: 1;
        padding: 10px;
        border: 1px solid #ccc;
        border-radius: 4px 4px 0 0;
        background: #f9f9f9;
        color: #ba9d31;
        cursor: pointer;
        font-size: 16px;

        &:first-child {
            border-radius: 4px 4px 0 0;
        }

        &.selected {
            background: #fff;
            border-bottom: 1px solid #fff;
            color: #000;
            font-weight: 600;
        }
    }
`
